module.exports = __webpack_public_path__ + "static/media/play-icon.5a81df0b.svg";